import { EventOrigin } from 'types/graphql/constants/EventOrigin'

export const EVENT_ORIGIN: { [key in EventOrigin]: EventOrigin } = {
  OFFER_DETAILS: 'OFFER_DETAILS',
  STORE_DETAILS: 'STORE_DETAILS'
}
